export default __webpack_public_path__ + "static/media/bg2.f870fae2.jpeg";